module.exports = __webpack_public_path__ + "assets/img/28_1075_big.7eeaa209.jpg";